import { screenSizeActions } from "../../services";

const getSize = ()=>{
    return {
        width:window.innerWidth, 
        height:window.innerHeight
    }
}
export const screenSizeReducer = ( state = {width:window.innerWidth, height:window.innerHeight}, action ) => {
    switch ( action.type ) {
      case screenSizeActions.RESIZE:
        return getSize();
      default:
        return state;
    }
  };